/**
 * SVDemo Veneer Configuration
 *
 * 32°-inspired SchoolVision Demo tenant.
 * Near-black charcoal-navy + electric blue on a pure white canvas.
 * Used for sales demos and prospect walkthroughs.
 */

export const svdemoVeneerConfig = {
  name: 'svdemo',
  displayName: 'SchoolVision Demo Store',
  parentBrand: 'SchoolVision',

  features: {
    megaMenu: false,
    searchBar: true,
    scrollEffects: true,
    heroSection: true,
    quickActions: false,
    demoModeBanner: true,
    promoBanner: true,
    quickAddEnabled: true,
    imageHoverCrossfade: true,
    stickyHeader: true,
  },

  colors: {
    primary: '#1A1A2E',
    primaryLight: '#2D2D4A',
    primaryDark: '#0F0F1E',
    accent: '#0EA5E9',
    accentHover: '#0284C7',
    headerBg: '#1A1A2E',
    ctaButton: '#0EA5E9',
    ctaButtonText: '#FFFFFF',
    ctaButtonHover: '#0284C7',
  },

  assets: {
    logo: '/images/svailogo.png',
    favicon: '/images/svailogo.png',
  },

  contact: {
    email: 'demo@schoolvision.ai',
    phone: '(801) 000-0000',
    address: 'Demo Mode — No Physical Location',
    website: 'https://schoolvision.ai',
    demoUrl: 'https://schoolvision.ai/demo',
  },

  content: {
    heroTitle: 'THE SMART CAMPUS STORE',
    heroSubtitle: 'Where attendance, payments, and analytics connect into one seamless platform.',
    ctaPrimary: 'EXPLORE THE STORE',
    ctaSecondary: 'REQUEST A DEMO',
    promoBannerText: '🎓 DEMO MODE — Explore SchoolVision\'s campus ecommerce platform',
    trustBand: {
      secure: 'Secure Checkout',
      guest: 'Guest Checkout Available',
      fast: 'Instant Processing',
      compliant: 'PCI Compliant',
    },
  },
}

export default svdemoVeneerConfig
